module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[6]371.67382ee.woff2";